import { Link } from "@tanstack/react-router";

import { ResponsiveImage } from "@/components/site/ResponsiveImage";
import { Reveal } from "@/components/site/Reveal";
import { business } from "@/lib/business";
import { imageSizes, logoImage } from "@/lib/images";

const footerNav = [
  { label: "Services", to: "/services" as const },
  { label: "About", to: "/about" as const },
  { label: "Contact", to: "/contact" as const },
];

export function Footer() {
  return (
    <footer className="border-t border-border bg-secondary/40">
      <div className="h-2 checker-strip" aria-hidden="true" />
      <Reveal className="mx-auto flex max-w-6xl flex-col gap-8 px-4 py-12 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <Link to="/" className="flex items-center gap-3">
            <ResponsiveImage
              image={logoImage}
              alt=""
              sizes={imageSizes.logoFooter}
              pictureClassName="size-12 shrink-0"
              imgClassName="size-12 rounded-sm bg-steel p-0.5"
            />
            <span className="font-display text-xl">{business.name}</span>
          </Link>
          <address className="mt-2 text-xs text-muted-foreground not-italic">
            <a
              href={business.mapsUrl}
              className="underline-offset-4 hover:text-foreground hover:underline"
            >
              {business.address}, {business.city}, {business.state} {business.zip}
            </a>
          </address>
        </div>

        <nav
          aria-label="Footer"
          className="flex flex-wrap gap-x-6 gap-y-2 text-sm font-semibold uppercase tracking-wider"
        >
          {footerNav.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              activeOptions={{ exact: true }}
              className="inline-flex min-h-11 items-center transition-colors hover:text-foreground"
              activeProps={{ className: "text-primary-text", "aria-current": "page" }}
              inactiveProps={{ className: "text-muted-foreground" }}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="text-sm text-muted-foreground sm:text-right">
          <a
            href={business.phoneHref}
            className="font-display text-2xl text-foreground"
            aria-label={`Call Champion Automotive Machine Shop at ${business.phone}`}
          >
            {business.phone}
          </a>
          <p className="mt-1">{business.hours}</p>
          <p className="mt-1">{business.lunchBreak}</p>
          <p className="mt-3 text-xs">
            © {new Date().getFullYear()} {business.name}. All machine work guaranteed.
          </p>
        </div>
      </Reveal>
    </footer>
  );
}
